import store from '@/store/index.js'
import router from '@/router';

/* eslint-disable no-console */
export const getPlatform = function () {
  let webLog = {}
  let userAgent = navigator.userAgent

  // 用户设备: 2: windows , 1: android, 0: iphone
  let userPlatform = 2

  // 获取微信版本
  let m1 = userAgent.match(/MicroMessenger.*?(?= )/)
  if (m1 && m1.length > 0) {
    webLog.wechat = m1[0]
  }
  // windows 电脑
  if (userAgent.includes('Windows')) {
    webLog.device = 'windows'
    userPlatform = 2
  }
  // 苹果手机
  if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    userPlatform = 0

    // 获取设备名
    if (userAgent.includes('iPad')) {
      webLog.device = 'iPad'
    } else {
      webLog.device = 'iPhone'
    }
    // 获取操作系统版本
    m1 = userAgent.match(/iPhone OS .*?(?= )/)
    if (m1 && m1.length > 0) {
      webLog.system = m1[0]
    }
  }
  // 安卓手机
  if (userAgent.includes('Android')) {
    userPlatform = 1
    // 获取设备名
    m1 = userAgent.match(/Android.*; ?(.*(?= Build))/)
    if (m1 && m1.length > 1) {
      webLog.device = m1[1]
    }
    // 获取操作系统版本
    m1 = userAgent.match(/Android.*?(?=;)/)
    if (m1 && m1.length > 0) {
      webLog.system = m1[0]
    }
  }


  // store.commit('user/setPlatform', userPlatform)
  // store.commit('user/setWexinBrowser', wexinBrowser)
  return userPlatform
}

export const getWexinBrowser = function () {
  let userAgent = navigator.userAgent
  let m1 = userAgent.match(/MicroMessenger.*?(?= )/)
  if (m1 && m1.length > 0) {
    return true
  }
  return false
}

const validIPAddress = function (queryIP) {
  // const ipTypes  = [
  //   "IPv4",
  //   "IPv6"
  // ]
  // 先以ipv4分割
  let arr = queryIP.split(".");
  let str = "IPv4";
  // 不是ipv4
  if (arr.length == 1) {
    arr = queryIP.split(":");
    str = "IPv6";
  }
  // 判断长度是否符合
  if (str == "IPv4") {
    if (arr.length !== 4) return "Neither";
  } else {
    if (arr.length !== 8) return "Neither";
  }
  for (let i = 0; i < arr.length; i++) {
    if (str == "IPv4") {
      // 验证ipv4
      if (arr[i] == "") return "Neither";
      let t = parseInt(arr[i], 10);
      if (t.toString().length !== arr[i].length || t < 0 || t > 255) return "Neither";
    } else {
      // 验证ipv6
      if (arr[i].length == 0 || arr[i].length > 4) return "Neither";
      let t = arr[i].match(/[a-fA-F0-9]/g);
      if (!t || t.length !== arr[i].length) return "Neither";
    }
  }
  return str;
}


export function getLocalIp() {
  const ipTypes = [
    "IPv4",
    "IPv6",
    'Neither'
  ]
  const defaultIP = '117.122.241.235'
  //  首页使用默认IP
  // store.commit('user/setUserIP', defaultIP)

  window.ipCallback = function (i) {
    let ip = i['ip'] || defaultIP
    const ipType = validIPAddress(ip)
    // 判断是否为 ipv4 的IP，
    // 如果不是，使用默认IP
    if (ipType !== ipTypes[0]) {
      ip = defaultIP
    }
    store.commit('user/setUserIP', ip)
    tar.removeChild(s)
  };
  var s = document.createElement('script');
  s.setAttribute('async',true)
  s.src = 'https://www.taobao.com/help/getip.php';
  var tar = document.querySelector("body");
  tar.appendChild(s);
}

// export function getLocalIp() {
//   console.log();
//   var s = document.createElement('script');
//   s.src = 'https://pv.sohu.com/cityjson?ie=utf-8';
//   var tar = document.querySelector("body");
//   tar.appendChild(s);
//   s.onload = function () {
//     const IP = returnCitySN["cip"]
//     const ipAddress = returnCitySN["cname"]
//     console.log(IP + ',' + ipAddress)
//     tar.removeChild(s);
//     store.commit('user/setUserIP', IP)
//   };
// }

export function getLogname() {
  const query = router['history']['current']['query']
  const queryLogname = query.logname || query.admLogName
  if (query && queryLogname) {
    sessionStorage.setItem('logname', queryLogname)
  }
  const logname = sessionStorage.getItem('logname')
  return logname
}

export function getUserMobile() {
  const mobile = sessionStorage.getItem('mobile')
  return mobile
}

export function getUserToken() {
  const token = sessionStorage.getItem('token')
  return token
}

// SourceID  
export function getSourceId() {
  const query = router['history']['current']['query']
  const querySource = query.sourceId || query.source
  if (query && querySource) {
    sessionStorage.setItem('sourceId', querySource)
  }
  const sourceId = sessionStorage.getItem('sourceId')

  return sourceId
}


